import config from 'config';
import {utility} from "../utilites/index";
import ActiveRecordResource from "./ActiveRecordResource";

export interface CountryDTO{
  name: string;
  code: string;
}

export class Country extends ActiveRecordResource {
  code: string;
  name: string;

  static path = `${config.backOfficeBasePath}/streams/countries`;

  static validateConstraints = {};

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  _getModel() {
    return Country;
  }

  static listAction(query) {
    let path = this.path;

    query = Object.assign({}, query);
    return utility.networkLayer.getJson(path, query)
      .then(data => this.mapRecords(data));
  }

  private static parseData(data: CountryDTO) {
    let res = new Country({});

    return Object.assign(res, res._parseData(data));
  }

  _parseData(data: CountryDTO) {
    let res: any = {
      code: data.code,
      name: data.name
    };

    return res;
  }

  get id(){
    return this.code;
  }
}

export default Country;



// WEBPACK FOOTER //
// ./src/api/country.ts